// extracted by mini-css-extract-plugin
module.exports =  {"root":"ButtonLink-module__root--G_ty2","label":"ButtonLink-module__label--Hr1Ix","labelReversed":"ButtonLink-module__labelReversed--_XXjS"};